export const RECONCILIATION_REQUEST_ITEMS_RESET_STATE = 'RECONCILIATION_REQUEST_ITEMS_RESET_STATE';
export const RECONCILIATION_REQUEST_ITEMS_CURRENT_ITEM = 'RECONCILIATION_REQUEST_ITEMS_CURRENT_ITEM';

export const RECONCILIATION_REQUEST_ITEMS_REQUEST_LOADING = 'RECONCILIATION_REQUEST_ITEMS_REQUEST_LOADING';
export const RECONCILIATION_REQUEST_ITEMS_REQUEST_SUCCESS = 'RECONCILIATION_REQUEST_ITEMS_REQUEST_SUCCESS';
export const RECONCILIATION_REQUEST_ITEMS_REQUEST_FAILED = 'RECONCILIATION_REQUEST_ITEMS_REQUEST_FAILED';

export const RECONCILIATION_REQUEST_ITEMS_CURRENT_ACTION = 'RECONCILIATION_REQUEST_ITEMS_CURRENT_ACTION';
export const RECONCILIATION_REQUEST_ITEMS_RESET_ACTION = 'RECONCILIATION_REQUEST_ITEMS_RESET_ACTION';